/**
 * Format a signed percent change for trend tiles. `null` (not computable)
 * renders as an em dash. Positive values get an explicit `+`; negative values
 * already carry `-` from `toFixed`.
 */
export function formatPercent(pct: number | null): string {
  if (pct === null || Number.isNaN(pct)) {
    return "—";
  }
  const sign = pct > 0 ? "+" : "";
  return `${sign}${pct.toFixed(1)}%`;
}
